import { siteContentEs, siteContentEn } from './siteContent';
import { orthoPagesEs, orthoPagesEn } from './orthoPagesContent';

export const STORAGE_KEY = 'smileup-locale';
export const DEFAULT_LOCALE = 'es';

const coreEs = {
  lang: {
    switchLabel: 'Idioma',
    menuLabel: 'Elegir idioma',
    es: 'ES',
    en: 'EN',
    nameEs: 'Español',
    nameEn: 'English',
  },
  nav: {
    home: 'Inicio',
    services: 'Tratamientos',
    about: 'Nosotros',
    contact: 'Ubícanos',
    blog: 'Blog',
    bookings: 'Reservas',
    login: 'Iniciar sesión',
    reservationsPanel: 'Panel de reservas',
    adminBlog: 'Admin blog',
    logout: 'Cerrar sesión',
    account: 'Mi cuenta',
    openMenu: 'Abrir menú',
    closeMenu: 'Cerrar menú',
  },
  topbar: {
    ariaLabel: 'Contacto y horarios',
    hoursLabel: 'Horarios:',
    hours: 'Lunes a Viernes 9:00–19:00 · Sábados 9:00–13:00',
    callAria: 'Llamar al (084) 607 539',
    whatsappAria: 'Contactar por WhatsApp',
    socialAria: 'Redes sociales',
    socialFacebook: 'Facebook',
    socialInstagram: 'Instagram',
    socialTiktok: 'TikTok',
    socialYoutube: 'YouTube',
    patientLogin: 'Paciente Login',
  },
  home: {
    overline: 'Smile Up · Ortodoncia en Cusco',
    titleTop: 'Brackets y alineadores',
    titleBottom: 'en Cusco',
    lead:
      'Soy el Dr. Germán Paniura, ortodoncista en Cusco. Trato tu sonrisa con brackets metálicos, brackets estéticos y alineadores invisibles. Evaluación ortodóncica para niños, jóvenes y adultos.',
    leadSecondaryPrefix: '¿Buscas',
    leadSecondaryOr: 'o',
    kwOrthodontics: 'ortodoncia en Cusco',
    kwBraces: 'brackets en Cusco',
    kwAligners: 'alineadores en Cusco',
    trustAria: 'Servicios de ortodoncia',
    trustBraces: 'Brackets y alineadores',
    trustOrtho: 'Ortodoncia en Cusco',
    trustLang: 'Español e inglés',
    emergencyBannerTitle: '¿Emergencia dental en Cusco?',
    emergencyBannerText:
      'Atención urgente para viajeros: dolor de muela, diente roto, inflamación o empaste perdido.',
    emergencyBannerCta: 'Ver página de emergencias (EN)',
    contactBoxAria: 'Contacto de la clínica',
    card1Title: 'Brackets estéticos y metálicos en Cusco',
    card1Text:
      'Ortodoncia fija en Cusco: brackets metálicos para máximo control y brackets estéticos más discretos. En la evaluación te explico cuál conviene según tu mordida y estilo de vida.',
    card1Cta: 'Brackets en Cusco',
    card2Title: 'Alineadores invisibles en Cusco',
    card2Text:
      'Invisalign y alineadores transparentes en Cusco: ortodoncia removible, discreta y planificada digitalmente. Ideal si buscas corregir tu sonrisa sin brackets visibles.',
    card2Cta: 'Alineadores en Cusco',
    card3Title: 'Evaluación de ortodoncia en Cusco',
    card3Text:
      'Primera cita conmigo para valorar brackets o alineadores. Reserva en línea y resuelve tus dudas con el doctor.',
    card3Cta: 'Agendar evaluación',
    whatsappMsg: 'Hola, me gustaría más información.',
    faqHeading: 'Preguntas frecuentes sobre ortodoncia',
    faqIntro:
      'Como ortodoncista en Cusco, respondo las dudas que más escucho en consulta. Si la tuya no está aquí, agenda tu evaluación y te la aclaro en persona.',
    faqAria: 'Preguntas y respuestas sobre tratamiento de ortodoncia',
    faqCta: 'Reservar evaluación con el doctor',
    faqItems: [
      {
        q: '¿Cuánto cuesta la ortodoncia con brackets o alineadores en Cusco?',
        a: 'El costo depende de la complejidad de tu caso, la técnica —brackets metálicos, estéticos o alineadores— y la duración estimada. En tu primera consulta te doy un presupuesto por fases, sin sorpresas, antes de iniciar.',
      },
      {
        q: '¿Brackets metálicos, estéticos o Invisalign: cuál me conviene?',
        a: 'Lo defino tras revisar tu mordida, alineación y estilo de vida. Los metálicos suelen ser muy efectivos; los estéticos son más discretos; los alineadores funcionan bien en casos seleccionados. Te explico pros y contras de cada opción.',
      },
      {
        q: '¿Cuánto dura el tratamiento y cuántas citas necesito?',
        a: 'Muchos tratamientos duran entre 18 y 24 meses, pero varía según el caso. Los controles suelen ser cada 4 a 6 semanas. Te indico un calendario realista desde la evaluación inicial.',
      },
      {
        q: '¿Atiendes a niños, jóvenes y adultos?',
        a: 'Sí. Trato ortopedia maxilar en niños, ortodoncia completa en adolescentes y adultos. Nunca es tarde para evaluar tu sonrisa si buscas alineación o corrección de mordida.',
      },
      {
        q: '¿Duele colocar brackets o usar alineadores?',
        a: 'Puede haber presión leve los primeros días tras un ajuste o al cambiar alineadores; es normal y suele ceder rápido. Te indico cómo aliviar molestias y qué señales requieren revisión.',
      },
      {
        q: '¿Puedo iniciar ortodoncia si estoy de visita en Cusco?',
        a: 'Sí. Atiendo pacientes internacionales en español e inglés. Puedo iniciar tu tratamiento, entregarte alineadores o programar controles según tus fechas de viaje.',
      },
    ],
  },
  seo: {
    homeTitle:
      'Ortodoncia en Cusco | Brackets y Alineadores | Smile Up',
    homeDescription:
      'Smile Up — Dr. Germán Paniura, ortodoncista en Cusco: brackets, alineadores, ortopedia maxilar, retenedores y microimplantes. Evaluación ortodóncica para niños, jóvenes y adultos.',
  },
};

const coreEn = {
  lang: {
    switchLabel: 'Language',
    menuLabel: 'Choose language',
    es: 'ES',
    en: 'EN',
    nameEs: 'Español',
    nameEn: 'English',
  },
  nav: {
    home: 'Home',
    services: 'Treatments',
    about: 'About us',
    contact: 'Location',
    blog: 'Blog',
    bookings: 'Bookings',
    login: 'Sign in',
    reservationsPanel: 'Bookings panel',
    adminBlog: 'Blog admin',
    logout: 'Sign out',
    account: 'My account',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
  },
  topbar: {
    ariaLabel: 'Contact and hours',
    hoursLabel: 'Hours:',
    hours: 'Mon–Fri 9:00 AM–7:00 PM · Sat 9:00 AM–1:00 PM',
    callAria: 'Call (084) 607 539',
    whatsappAria: 'Contact us on WhatsApp',
    socialAria: 'Social media',
    socialFacebook: 'Facebook',
    socialInstagram: 'Instagram',
    socialTiktok: 'TikTok',
    socialYoutube: 'YouTube',
    patientLogin: 'Patient Login',
  },
  home: {
    overline: 'Smile Up · Orthodontics in Cusco',
    titleTop: 'Braces and aligners',
    titleBottom: 'in Cusco',
    lead:
      'I am Dr. Germán Paniura, orthodontist in Cusco. I treat your smile with metal braces, ceramic braces and clear aligners. Orthodontic evaluation for children, teens and adults.',
    leadSecondaryPrefix: 'Looking for',
    leadSecondaryOr: 'or',
    kwOrthodontics: 'orthodontics in Cusco',
    kwBraces: 'braces in Cusco',
    kwAligners: 'aligners in Cusco',
    trustAria: 'Orthodontic services',
    trustBraces: 'Braces and aligners',
    trustOrtho: 'Orthodontics in Cusco',
    trustLang: 'English and Spanish',
    emergencyBannerTitle: 'Dental emergency in Cusco?',
    emergencyBannerText:
      'Same-day care for tourists — toothache, broken tooth, swelling or lost filling.',
    emergencyBannerCta: 'See the emergency dentist page',
    contactBoxAria: 'Clinic contact',
    card1Title: 'Ceramic and metal braces in Cusco',
    card1Text:
      'Fixed orthodontics in Cusco: metal braces for maximum control and aesthetic ceramic braces for a more discreet look. At your evaluation I explain which option fits your bite and lifestyle.',
    card1Cta: 'Braces in Cusco',
    card2Title: 'Clear aligners in Cusco',
    card2Text:
      'Invisalign and clear aligners in Cusco: removable, discreet orthodontics with digital planning. Ideal if you want to straighten your smile without visible braces.',
    card2Cta: 'Aligners in Cusco',
    card3Title: 'Orthodontic consultation in Cusco',
    card3Text:
      'First visit with me to assess braces or aligner treatment. Book online and get answers from the doctor.',
    card3Cta: 'Book consultation',
    whatsappMsg: 'Hello, I would like more information.',
    faqHeading: 'Frequently asked questions about orthodontics',
    faqIntro:
      'As an orthodontist in Cusco, I answer the questions I hear most in consultation. If yours is not listed, book your evaluation and I will clarify it in person.',
    faqAria: 'Orthodontic treatment questions and answers',
    faqCta: 'Book your evaluation with the doctor',
    faqItems: [
      {
        q: 'How much does orthodontic treatment with braces or aligners cost in Cusco?',
        a: 'Cost depends on case complexity, technique —metal braces, ceramic braces or aligners— and estimated duration. At your first visit I provide a phased budget with no surprises before starting.',
      },
      {
        q: 'Metal braces, ceramic braces or Invisalign: which is best for me?',
        a: 'I decide after reviewing your bite, alignment and lifestyle. Metal braces are often very effective; ceramic braces are more discreet; aligners work well in selected cases. I explain the pros and cons of each option.',
      },
      {
        q: 'How long does treatment take and how many appointments will I need?',
        a: 'Many treatments last 18–24 months, but it varies by case. Check-ups are usually every 4–6 weeks. I give you a realistic calendar from the initial evaluation.',
      },
      {
        q: 'Do you treat children, teens and adults?',
        a: 'Yes. I provide maxillary orthopedics for children, full orthodontics for teens and adults. It is never too late to evaluate your smile if you want alignment or bite correction.',
      },
      {
        q: 'Does getting braces or wearing aligners hurt?',
        a: 'Mild pressure is normal for a few days after an adjustment or when changing aligners; it usually fades quickly. I tell you how to relieve discomfort and which signs need a review.',
      },
      {
        q: 'Can I start orthodontics while visiting Cusco?',
        a: 'Yes. I treat international patients in Spanish and English. I can start your treatment, deliver aligners or schedule check-ups around your travel dates.',
      },
    ],
  },
  seo: {
    homeTitle:
      'Orthodontics in Cusco | Braces & Aligners | Smile Up',
    homeDescription:
      'Smile Up — Dr. Germán Paniura, orthodontist in Cusco: braces, aligners, maxillary orthopedics, retainers and mini-implants. Orthodontic evaluation for children, teens and adults.',
  },
};

export const translations = {
  es: {
    ...coreEs,
    ...siteContentEs,
    orthoPages: orthoPagesEs,
    seo: { ...coreEs.seo, ...siteContentEs.seo },
  },
  en: {
    ...coreEn,
    ...siteContentEn,
    orthoPages: orthoPagesEn,
    seo: { ...coreEn.seo, ...siteContentEn.seo },
  },
};

function getByPath(obj, path) {
  return path.split('.').reduce((acc, key) => (acc == null ? acc : acc[key]), obj);
}

function interpolate(str, vars) {
  if (!vars || typeof str !== 'string') return str;
  return str.replace(/\{\{(\w+)\}\}/g, (_, k) =>
    vars[k] != null ? String(vars[k]) : ''
  );
}

export function translate(locale, key, vars) {
  const loc = locale === 'en' ? 'en' : DEFAULT_LOCALE;
  let value = getByPath(translations[loc], key);
  if (value == null) value = getByPath(translations[DEFAULT_LOCALE], key);
  if (value == null) return key;
  return interpolate(value, vars);
}
